<template>
  <div id="hrms16x">
    <hrms-search-box-table v-show="indexDisp"
            v-model="searchIndex"
            :data="index"
            :nowLang="dash.nowLang"
            :columns="columns[dash.nowLang].index"
            :unLoadBool="true"
            :receivedStore="receivedHrms16xIndex"
            :columnEvent="columnEvent"
            :csvExportDisp="true"
            searchBoxAlias="hrms16x"
            :callSearchEvent="callSearchEvent" />

  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import * as types from 'store/modules/hrms16x/mutation-types'
import moment from 'moment'

export default {
  name: 'hrms16x',
  data () {
    return {
      searchIndex: {
        year: moment().format('YYYY'),
        numtime: '1'
      },
      dash: this.$parent.$parent.$parent,
      dtereq: moment().format('DD/MM/YYYY')
    }
  },
  created () {
    this.receivedHrms16xColumnsLabels()
  },
  computed: {
    codempid () {
      let currentUser = this.dash.currentUser
      return currentUser.p_codempid
    },
    ...mapGetters({
      indexDisp: types.GET_HRMS16X_INDEX_DISP,
      columns: types.GET_HRMS16X_COLUMNS,
      labels: types.GET_HRMS16X_LABELS,
      index: types.GET_HRMS16X_INDEX
    })
  },
  methods: {
    callSearchEvent () {
      if (this.searchIndex.codempid3 !== '') {
        this.searchIndex.codcomp = ''
        this.searchIndex.codpos = ''
      }
    },
    ...mapMutations({
      setIndexSelected: types.SET_HRMS16X_INDEX_SELECTED
    }),
    ...mapActions({
      toggle: types.TOGGLE_HRMS16X_PAGE,
      receivedHrms16xColumnsLabels: types.RECEIVED_HRMS16X_COLUMNS_LABELS,
      receivedHrms16xIndex: types.RECEIVED_HRMS16X_INDEX
    })
  }
}
</script>



// WEBPACK FOOTER //
// component.vue?55b23ade